module.exports = {
	"production": {
		"UrlApi": "https://app.projecao.br/ccgp/api",
		"UrlBase": "https://app.projecao.br/ccgp"
	},
	"development": {
		"UrlApi": "https://localhost:44341/ccgp/api",
		"UrlBase": "https://localhost:44341/ccgp"
	},
	"homologation": {
		"UrlApi": "https://app.projecao.br/ccgp_homologacao/api",
		"UrlBase": "https://app.projecao.br/ccgp_homologacao"
	},
	"training": {
		"UrlApi": "https://app.projecao.br/ccgp_treinamento/api",
		"UrlBase": "https://app.projecao.br/ccgp_treinamento"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/core/config/central-app-env.json
// module id = 303
// module chunks = 1